
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shorten'
})

export class ShortenPipe implements PipeTransform {
    transform(value: string, limit = 25, add = '...') {
        if (value != null) {
            return value.length > limit ? value.substr(0, limit) + add : value;
        }
    }
}